var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrentTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "22px",
    viewBox: "0 0 26 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "last_version",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04_DETALLE_CAMPA\\xD1A",
    transform: "translate(-41.000000, -146.000000)",
    stroke: "currentColor",
    strokeWidth: 2.08333333
  }, /*#__PURE__*/React.createElement("g", {
    id: "sidebar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.625,18.75 L15.625,16.6666667 C15.625,14.3654802 13.7595198,12.5 11.4583333,12.5 L4.16666667,12.5 C1.86548021,12.5 0,14.3654802 0,16.6666667 L0,18.75",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.8125,
    cy: 4.16666667,
    r: 4.16666667
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "16.6666667 8.33333333 18.75 10.4166667 22.9166667 6.25"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentTask);
export default __webpack_public_path__ + "static/media/currentTask.0f2495b1f4190ff851b48bb7401a70db.svg";
export { ForwardRef as ReactComponent };